import * as api from '../api/internalAdministration';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_ADMINISTRATION_NIGHTLY_TOTALS = createRequestTypes(
  `${prefix}/FETCH_ADMINISTRATION_NIGHTLY_TOTALS`,
);

export const fetchAdministrationNightlyTotals = makeApiActionCreatorV3(
  api.fetchAdministrationNightlyTotals,
  FETCH_ADMINISTRATION_NIGHTLY_TOTALS[START],
  FETCH_ADMINISTRATION_NIGHTLY_TOTALS[SUCCESS],
  FETCH_ADMINISTRATION_NIGHTLY_TOTALS[ERROR],
);

export const QUERY_EXECUTOR_ADMINISTRATION = createRequestTypes(
  `${prefix}/QUERY_EXECUTOR_ADMINISTRATION`,
);

export const queryExecutorAdministration = makeApiActionCreatorV3(
  api.queryExecutorAdministration,
  QUERY_EXECUTOR_ADMINISTRATION[START],
  QUERY_EXECUTOR_ADMINISTRATION[SUCCESS],
  QUERY_EXECUTOR_ADMINISTRATION[ERROR],
);

export const FETCH_PROPERTY_LETTER_FIELDS = createRequestTypes(
  `${prefix}/FETCH_PROPERTY_LETTER_FIELDS`,
);

export const fetchPropertyLetterFields = makeApiActionCreatorV3(
  api.fetchPropertyLetterFields,
  FETCH_PROPERTY_LETTER_FIELDS[START],
  FETCH_PROPERTY_LETTER_FIELDS[SUCCESS],
  FETCH_PROPERTY_LETTER_FIELDS[ERROR],
);

export const GET_RENDERED_HTML = createRequestTypes(
  `${prefix}/GET_RENDERED_HTML`,
);

export const getRenderedHtml = makeApiActionCreatorV3(
  api.getRenderedHtml,
  GET_RENDERED_HTML[START],
  GET_RENDERED_HTML[SUCCESS],
  GET_RENDERED_HTML[ERROR],
);

export const GENERATE_LETTER_PDF = createRequestTypes(
  `${prefix}/GENERATE_LETTER_PDF`,
);

export const generateLetterPDF = makeApiActionCreatorV3(
  api.generateLetterPDF,
  GENERATE_LETTER_PDF[START],
  GENERATE_LETTER_PDF[SUCCESS],
  GENERATE_LETTER_PDF[ERROR],
);
